import { useSelector } from 'react-redux'
import { getInternalIdentity } from 'src/selectors/internalAuth'

// One shared empty list, so a missing identity never hands consumers a new array per render.
const NO_PERMISSIONS: string[] = []

/**
 * The signed-in internal user's permission list. Stable between renders (the identity is loaded
 * once per sign-in by `RequireInternalAuth`), so it is safe in dependency arrays.
 */
export const useInternalPermissions = (): string[] => {
  const identity = useSelector(getInternalIdentity)

  return identity ? identity.permissions : NO_PERMISSIONS
}
